<template>
	<div class="service-icon" :style="`width: ${size}; height: ${size};`">
		<div class="round" :style="`background-color: ${color};`"></div>
		<div class="icon">
			<div
				v-if="isInlineSvg"
				class="svg-icon"
				:style="`fill:${color};`"
				v-html="sanitizedSvg"
			></div>
			<simple-svg v-else :filepath="src" :fill="color" class="svg-icon"/>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'ServiceIcon',
		props: {
			src: {
				type: String,
				required: true
			},
			size: {
				type: String,
				required: true
			},
			color: {
				type: String,
				required: false
			}
		},
		computed: {
			/** The services API returns either a URL or the raw SVG content */
			isInlineSvg() {
			return typeof this.src === "string" && this.src.indexOf("<svg") !== -1;
			},
			sanitizedSvg() {
			return this.src
				.replace(/<script[\s\S]*?<\/script>/gi, "")
				.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
			}
		},

		methods: {
			// ifSvg(src) {
			// 	return src.split(".").pop() == "svg";
			// },
			// svgSrc(src) {
			// 	if (!this.$isUrl(src)) {
			// 		return src;
			// 	}
			// 	const API_URL = process.env.VUE_APP_BACKEND_API_URL;
			// 	const url = API_URL + "/api/asset-content?url=" + encodeURIComponent(src);
			// 	return url;
			// }
		}
	};
</script>

<style lang="scss">
	.service-icon {
		position: relative;
		.round {
			position: absolute;
			-webkit-border-radius: 50%;
			border-radius: 50%;
			background: #eeeeee;
			opacity: 0.1;
			top: 0;
			width: 100%;
			height: 100%;
			left: 0;
			z-index: 0;
			transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
			-moz-transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
			-webkit-transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
		}
		.icon {
			position: relative;
			margin: 0 auto;
			padding: 25%;
			width: 100%;
			height: 100%;
			text-align: center;
			transition: all 0.8s cubic-bezier(0.2, 1, 0.2, 1);
			-moz-transition: all 0.8s cubic-bezier(0.2, 1, 0.2, 1);
			-webkit-transition: all 0.8s cubic-bezier(0.2, 1, 0.2, 1);
			transition-delay: 0.1s;
			.svg-icon {
				position: relative;
				svg {
					position: absolute;
					top: 0;
					left: 0;
				}
			}
		}
	}
</style>